import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { get as _get, keyBy as _keyBy, values as _values } from 'lodash';

import { PhotoUploadAction, PhotoUploadActionTypes } from './photo-upload.actions';
import { ClaimPhoto } from './photo-upload.model';

export const PHOTOUPLOAD_FEATURE_KEY = 'photoUpload';

export interface PhotoUploadState extends EntityState<ClaimPhoto> {}

export const adapter: EntityAdapter<ClaimPhoto> = createEntityAdapter<ClaimPhoto>({
  selectId: (claimPhoto: ClaimPhoto) => getClaimPhotoId(claimPhoto),
  sortComparer: false
});

export const initialState: PhotoUploadState = adapter.getInitialState();

export function photoUploadReducer(
  state: PhotoUploadState = initialState,
  action: PhotoUploadAction
): PhotoUploadState {
  switch (action.type) {
    case PhotoUploadActionTypes.PhotoUploadLoad: {
      return adapter.removeAll(state);
    }

    case PhotoUploadActionTypes.PhotoUploadLoadSuccess: {
      const filteredList = filterPhotos(_get(action, 'payload.rows', []));
      return adapter.setAll(filteredList, state);
    }

    default: {
      return state;
    }
  }
}

/**
 * @returns filteredPhotoList
 * @param claimPhotoList
 * @description Filters out all documents that are not claim photos
 */
function filterPhotos(claimPhotoList: ClaimPhoto[]) {
  return claimPhotoList.filter(index => {
    return (
      (index.metaData.find(data => {
        return data.name === 'Category Type';
      }).value === 'ESTIMATE RELATED PHOTO' ||
        index.metaData.find(data => {
          return data.name === 'Content Category';
        }).value === 'ESTIMATES AND RELATED PHOTOS') &&
      index.metaData
        .find(data => {
          return data.name === 'MimeType';
        })
        .value.includes('image')
    );
  });
}

/**
 * @returns photoId
 * @param claimPhoto
 * @description Finds the photo id
 */
function getClaimPhotoId(claimPhoto) {
  return claimPhoto.metaData.find(data => {
    return data.name === 'Id';
  }).value;
}
